import { Link } from "react-router";
import { Button } from "../components/Button";

export function NotFoundScreen() {
  return (
    <div className="app-column items-center justify-center gap-4 px-5 text-center">
      <h1 className="m-0 font-[family-name:var(--font-display)] text-[27px] font-bold">
        That page isn't here.
      </h1>
      <p className="m-0 text-[13.5px] text-text-muted">
        The link may be old. Your practice and scores are safe.
      </p>
      <Link to="/" className="w-full max-w-[280px] pt-2">
        <Button>Back to practice</Button>
      </Link>
    </div>
  );
}
